
import { defineComponent } from "vue";
import { toolbarWidthFluid } from "@/core/helpers/config";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  setup() {
    const { t } = useI18n();

    return {
      toolbarWidthFluid,
      t,
    };
  },
});
